export default "__VITE_ASSET__bc5372ed__"